export const DRAG_MODE = ({
  MOVE_NODE: 'MOVE_NODE',
  DRAW_EDGE: 'DRAW_EDGE'
} as const);
export type DragModeT = (typeof DRAG_MODE)[keyof typeof DRAG_MODE];
export const DATA_ATTR_NODE_ID = 'data-node-id';